import { Alert, Box, Button, Stack, styled } from '@mui/material';
import LoadingScreen from 'src/minimals/LoadingScreen';
import Page from 'src/minimals/Page';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useMutation } from '@apollo/client';
import invitationMutations from '../../gql/mutations/invitations';

const TreincoAppInvitation = ({ action }) => {
  const token = new URL(window.location.href).searchParams.get('token');
  const [acceptAppInvitation, acceptMutation] = useMutation(
    invitationMutations.ACCEPT_TREINCO_APP_INVITATION,
    {
      variables: {
        token,
      },
    }
  );
  const [rejectAppInvitation, rejectMutation] = useMutation(
    invitationMutations.REJECT_INVITATION,
    {
      variables: {
        token,
      },
    }
  );
  const [loading, setLoading] = useState(true);
  const [isNewUser, setIsNewUser] = useState(false);
  const error = acceptMutation.error || rejectMutation.error || !token;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (action !== 'accept' && action !== 'reject') return;

    if (action === 'accept') {
      acceptAppInvitation()
        .then(({ data }) => {
          setIsNewUser(Boolean(data?.acceptTreincoAppInvitation?.isNewUser));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }

    if (action === 'reject') {
      rejectAppInvitation().finally(() => {
        setLoading(false);
      });
    }
  }, [dispatch, action]);

  if (loading) return <LoadingScreen />;

  return (
    <RootStyle title={t('page.workspace.invitation')}>
      <ContentStyle>
        <Stack direction="row" alignItems="center">
          <Box sx={{ flexGrow: 1 }}>
            <Box
              component="img"
              alt="empty content"
              src="/static/illustrations/illustration_components.png"
              sx={{ height: 288, margin: 'auto', mb: 3 }}
            />
            <Stack>
              <Alert severity={!error ? 'success' : 'error'}>
                {!error
                  ? action === 'reject'
                    ? t('treinco_app_invitation.rejected')
                    : t(
                        isNewUser
                          ? 'treinco_app_invitation.success.new_user'
                          : 'treinco_app_invitation.success.existing'
                      )
                  : error.message}
              </Alert>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  navigate('/');
                }}
              >
                {t('customer_invitation.button.go_home')}
              </Button>
            </Stack>
          </Box>
        </Stack>
      </ContentStyle>
    </RootStyle>
  );
};

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 650,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
  flexGrow: 1,
}));

export default TreincoAppInvitation;
